module.exports = __webpack_public_path__ + "static/9-d92e043b501395dfe385544af70916a0.jpg";